import { styled } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import clsx from "clsx";
import SubTitle from "../Typography/SubTitle";

const StyledAccordion = styled(Accordion)(() => ({
  "&.MuiAccordion-root::before": {
    opacity: 0,
  },
  "&.MuiAccordion-root.Mui-expanded": {
    margin: "0px 0px 16px",
  },
}));

const StyledAccordionSummary = styled(AccordionSummary)(() => ({
  "&.MuiAccordionSummary-root.Mui-expanded": {
    minHeight: "48px",
  },
  "& .MuiAccordionSummary-content": {
    margin: "6px 0px",
    maxWidth: "100%",
    overflow: "hidden",
    "&.Mui-expanded": {
      margin: "6px 0px",
      maxWidth: "100%",
      overflow: "hidden",
    },
  },
  "&.summary": {
    "&.row-reverse": {
      flexDirection: "row-reverse",
    },
    "&.row": {
      flexDirection: "row",
    },
  },
  "& .summary-row": {
    display: "flex",
    width: "100%",
    maxWidth: "100%",
    justifyContent: "space-between",
    "& .title-container": {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      flexGrow: 1,
    },
  },
  "& .title": {
    whiteSpace: "nowrap",
  },
}));

const StyledAccordionDetails = styled(AccordionDetails)(() => ({
  padding: "0px 16px 16px",
}));

export default function BasicAccordion({
  title,
  titleIcon,
  titleAction,
  children,
  onChange,
  isInitiallyOpen,
  isOpen,
  expandPosition = "end", // "start" | "end"
  className,
  classNames = {}, // Expected classNames: title,details,summary
}) {
  return (
    <StyledAccordion
      onChange={onChange}
      defaultExpanded={isInitiallyOpen}
      className={className}
      expanded={isOpen}
    >
      <StyledAccordionSummary
        expandIcon={<ExpandMoreIcon />}
        className={clsx(
          "summary",
          expandPosition === "start" ? "row-reverse" : "row",
          classNames.summary
        )}
      >
        <div className="summary-row">
          {typeof title === "string" ? (
            <div className="title-container">
              {titleIcon}
              <SubTitle className={clsx("title", classNames.title)}>
                {title}
              </SubTitle>
            </div>
          ) : (
            title
          )}
          {titleAction}
        </div>
      </StyledAccordionSummary>
      <StyledAccordionDetails className={clsx("details", classNames.details)}>
        {children}
      </StyledAccordionDetails>
    </StyledAccordion>
  );
}
